module.exports = __webpack_public_path__ + "img/Group 27927.d15bf4b3.svg";